<div class="outsider-desktop">
    <div class="logo-inline">
        <img src="../assets/img/octa/octa-dark.png" />

        <div id="slogan">
            <h1 class="title">OCTA</h1>
            <p class="sub">WARRIORS ONLY</p>
        </div>
    </div>


    <img class="bgimg" src="../assets/img/octa/hero-desktop-crop.png" />

    <div class="appbox"></div>

    <div class="footer">
        <small>© Copyright 2018 - 2026 • Build the Future </small>
    </div>
</div>

<div id="outsider_wrapper" class="outsider" >
    <div class="box-logo">
        <img style="width: 66px; margin: 3% auto 0" src="../assets/img/octa/octa-dark.png" />

        <div id="slogan"
            style="position: relative; float: left; width: 100%; top: 21px;z-index: -1">
            <h1 class="title">OCTA</h1>
            <p class="sub">WARRIORS<br/>ONLY</p>
        </div>
    </div>

    <div id="guide">
        <h1>ACESSE SUA CONTA</h1>
        <p>SEJA BEM-VINDO</p>
    </div>

    <div class="frm">
        
        <!---.recover  -->
        <div class="eRecover input-wrapper" id="ghost_wrapper" style="opacity: 0;">
            <label class="has-float-label">
                <input #ghost type="email" (keyup.enter)="goHaylie('bringmeback')"
                    placeholder="email@exemplo.com" class="eRecover" aria-multiline="false" autocomplete="off" value="" />
                <span style="font-family: mysanslight;">EMAIL</span>
            </label>
        </div>
        <p class="help eRecover" style="display: none;">
            Não se preocupe, iremos lhe enviar um email com instruções para <br/>
            recuperar sua senha
            <!-- <br/><br/><br/>
            <fa-icon [icon]="FAIconRecover" style="font-size: 52px;color: #777;"></fa-icon>
            <br/><br/><br/> -->
        </p>
        <p id="eRecoverResult" class="help eRecoverResult" style="display: none;
            color: rgb(204, 204, 204);width: 70%;text-align: center;margin: 9px 15%;float: left;top: -30px;position: relative;margin-bottom: 36px;font-size: 16px;">
            
            <fa-icon [icon]="FAIconCheck" style="font-size: 34px; color: rgba(255,255,255,.7);"></fa-icon>
            <br/><br/><br/>       
            {{ response_msg }}<br/>
        </p>
        <p id="eDenied" class="help eDenied" style="display: none;
            color: rgb(204, 204, 204);width: 70%;text-align: center;margin: 9px 15%;float: left;top: -30px;position: relative;margin-bottom: 36px;font-size: 16px;">
            
            <fa-icon [icon]="FAIconDenied" style="font-size: 34px; color: rgba(255,255,255,.7);"></fa-icon>
            <br/><br/><br/>       
            {{ response_msg }}<br/>

        </p>

        <!---.register  -->
        <div class="frmtest eRegister" style="display:none; min-height: 340px;">
            <h4 style="">cadastro</h4>
            
            <ul class="steps" style="float: left; width: 70%; margin: 3px 15%;">
                <li><span id="sc1" class="stepcount {{ padawanstep >= 1 ? 'on' : '' }}"></span></li>
                <li><span id="sc2" class="stepcount {{ padawanstep >= 2 ? 'on' : '' }}"></span></li>
                <li><span id="sc3" class="stepcount {{ padawanstep >= 3 ? 'on' : '' }}"></span></li>
            </ul>
            <div class="regsteps" id="step1">
                <fa-icon [icon]="FAIconPremium" class="boxicon"
                    style="display: block; font-size: 61px; 
                    margin: 34px 0; color:#ff9900; text-align: center;"></fa-icon>

                <div style="margin-top: 3px;float: left; width: 100%;position: relative;">
                    <div class="eRegister" style="display: none;width: 210px;top: 9px; left: 50%;position: relative;margin-left: -105px;">
                        <label class="has-float-label">
                            <input #padawan type="nome" (keyup.enter)="goHaylie('register')" 
                                placeholder="seu nome" class="eRegister" aria-multiline="false" autocomplete="off" value="" />
                            <span style="font-family: mysanslight;">NOME</span>
                        </label>
                    </div>
                    <div class="eRegister" style="display: none;width: 210px;top: 90px; left: 50%;position: relative;margin-left: -105px;margin-bottom: 90px;">
                        <label class="has-float-label">
                            <input #padawanphone type="number" (keyup.enter)="goHaylie('register')" 
                                placeholder="11912345678" class="eRegister" aria-multiline="false" autocomplete="off" value="" />
                            <span style="font-family: mysanslight;">TELEFONE</span>
                        </label>
                    </div>
                </div>

                <p class="help eRegister" style="display: none;">
                    Primeiro precisamos do seu  <br/>
                    <b>nome & telefone</b><br/>
                    
                </p>
            </div>  
            <div class="regsteps" id="step2" style="display:none">
                <fa-icon [icon]="FAIconRegStep2" class="boxicon"
                    style="display: block; font-size: 61px; 
                    margin: 34px 0; color:#ff9900; text-align: center;"></fa-icon>

                <div style="margin-top: 3px;float: left; width: 100%;position: relative;">
                    
                    <p class="help eRegister" style="display: none;">
                        Agora precisamos de uma foto sua<br/>
                        para ser usada na rede <br/>
                        
                    </p>
                    
                    <app-comp-imgup class="eRegister" 
                        style="display: none;float: left;width: 100%;">
                    </app-comp-imgup>

                </div>
            </div>  
            <div class="regsteps" id="step3" style="display:none">
                <fa-icon [icon]="FAIconRegStep3" class="boxicon"
                    style="display: block; font-size: 61px; 
                    margin: 34px 0; color:#ff9900; text-align: center;"></fa-icon>

                <div class="eRegister" style="display: none;width: 210px;top: 9px; left: 50%;position: relative;margin-left: -105px;margin-bottom: 90px;">
                    <label class="has-float-label">
                        <input #padawanmail type="email" (keyup.enter)="goHaylie('register')" 
                            placeholder="seuemail@exemplo.com" class="eRegister" aria-multiline="false" autocomplete="off" value="" />
                        <span style="font-family: mysanslight;">EMAIL</span>
                    </label>
                </div>
                <p class="help eRegister" style="display: none;">
                    Agora é só confirmar seu e-mail<br/>
                    Enviaremos um link para liberação do seu acesso 
                </p>

            </div>  
        </div>  
        <p id="eRegisterResult" class="help eRegisterResult" style="display: none;
            color: rgb(204, 204, 204);width: 70%;text-align: center;margin: 9px 15%;float: left;top: -30px;position: relative;margin-bottom: 36px;font-size: 16px;">
            
            <fa-icon [icon]="FAIconCheck" style="font-size: 34px; color: rgba(255,255,255,.7);"></fa-icon>
            <br/><br/><br/>       
            Solicitação enviada com sucesso<br/><br/>
            Notificaremos a aprovação e liberação do seu acesso por email<br/><br/>

            <img style="width: 99px" src="../assets/img/categs/punch.png"   />

        </p>
        
        <!---.login  -->
        <div class="eLogin input-wrapper" id="mail_wrapper">
            <label class="has-float-label">
                <input #lmail type="email" (keyup.enter)="goHaylie('logmein')" 
                    placeholder="" class="eLogin" 
                    aria-multiline="false" 
                    autocomplete="off"  />
                <span style="font-family: mysanslight;">EMAIL</span>
            </label>
        </div>
        <div class="eLogin input-wrapper" id="key_wrapper" style="top: 54px;">
            <label class="has-float-label">
                <input #lkey name="lkey" class="eLogin usrinputkey" type="password" 
                    (keyup)="mirrorKey($event)"
                    (keyup.enter)="goHaylie('logmein')" 
                    placeholder="" title="" style="opacity: 1" aria-multiline="false" autocomplete="off" />
                <input #lkey2 name="lkey2" class="eLogin usrinputkey" type="text"  
                    placeholder="" title=""
                    (keyup)="mirrorKey($event)"
                    (keyup.enter)="goHaylie('logmein')" 
                    style="display: none;" aria-multiline="false" autocomplete="off" />
     
                <span style="font-family: mysanslight;">SENHA</span>
            </label>
            <p class="help eLogin"> 
                <a (click)="switchScreens('Recover')" style="color: #2d4f8e; font-weight: 600;"> Esqueceu a senha ?</a>
            </p>

            <a id="trg_locker" (click)="switchKeys()">
                <fa-icon class="lockico" id="locker" [icon]="FAIconLocker" style="font-size: 18px; opacity: 1;"></fa-icon>
                <fa-icon class="lockico" id="locker2" [icon]="FAIconLocker2" style="font-size: 18px; display: none;"></fa-icon>
            </a>
        </div>

        <a id="btn_go" class="btnrecblue eLogin" (click)="goHaylie('logmein')"
            style="width: 70%; margin: 9px 15%; border-radius: 4.3px;">ENTRAR</a>
        <a id="btn_recover" class="btnrecblue eRecover" (click)="goHaylie('bringmeback')" 
            style="display: none;position: relative;    top: 61px;
            width: 70%;margin: 9px 15%; border-radius: 4.3px;">ENVIAR</a>
        <a id="btn_register" class="btnrecblue eRegister" 
            (click)="switchSteps(true)" 
            style="display: none;position: relative;top: 61px;
            width: 70%; margin: 9px 15%;border-radius: 4.3px;">{{ btnregisterlabel }}</a>
        <a class="btnrectransp eRecover" (click)="switchScreens('Login')" 
            style="display: none;position: relative; top: 72px; font-size: 12px;">VOLTAR</a>
        <a class="btnrectransp eRegister" (click)="switchSteps(false)" 
            style="display: none;position: relative; top: 72px; font-size: 12px;">VOLTAR</a>


        <!-- <p class="help eLogin" 
            style="color: rgb(204, 204, 204);opacity: 0;font-size: 10px;margin: 0px;position: relative;top: 225px;float: left;text-align: center;width: 100%;"> 
            Ainda não tem conta ? <a (click)="switchScreens('Register')" style="color: #2d4f8e; font-weight: 600;"> Cadastre-se</a></p> -->
    </div>

    <div class="terms eLogin">
        <a>
            <p>Termos de uso <span>•</span> Política de privacidade</p>
        </a>
    </div>

</div>